import { FirstLoanOfferResponse } from 'api/typegen/application/first-loan-offer/get';
import { QueryStatus } from '@tanstack/react-query';
import useFirstLoanOfferQuery from 'ui/hooks/useFirstLoanOfferQuery';
import useLoanApplicationProcess from '../LoanApplicationProcessProvider/useLoanApplicationProcess';
import useTerm from 'ui/hooks/useTerm';

export interface LoanOffer {
  term?: number;
  firstPaymentInterest?: number;
  additionalAmountAdministrationFee?: number;
  annualPercentageRate?: number;
  totalRepayableAmount?: number;
  mtpAmount?: number;
  mtpLoanAmortizationAmount?: number;
  mtpInterestAmount?: number;
  mtpAdministrationFee?: number;
  mtpInvoicingFee?: number;
  mainAmountAdministrationFee?: number;
  agreementEndDate?: string;
  totalPrincipal?: number;
}

export interface UseLoanOffer {
  status: QueryStatus;
  loanOffer?: LoanOffer;
}

const useLoanOffer = () => {
  const { loanAmount } = useLoanApplicationProcess();
  const { term } = useTerm();
  const { firstLoanOffer, status } = useFirstLoanOfferQuery(loanAmount, term);

  return {
    loanOffer: firstLoanOffer
      ? firstLoanOfferToLoanOffer(firstLoanOffer)
      : undefined,
    status,
  };
};

export default useLoanOffer;

const firstLoanOfferToLoanOffer = (
  firstLoanOffer: FirstLoanOfferResponse,
): LoanOffer => ({
  term: firstLoanOffer.term,
  firstPaymentInterest: firstLoanOffer.firstPaymentInterest,
  additionalAmountAdministrationFee:
    firstLoanOffer.additionalAmountAdministrationFee,
  annualPercentageRate: firstLoanOffer.annualPercentageRate,
  totalRepayableAmount: firstLoanOffer.totalRepayableAmount,
  mtpAmount: firstLoanOffer.mtpAmount,
  mtpLoanAmortizationAmount: firstLoanOffer.mtpLoanAmortizationAmount,
  mtpInterestAmount: firstLoanOffer.mtpInterestAmount,
  mtpAdministrationFee: firstLoanOffer.mtpAdministrationFee,
  mtpInvoicingFee: firstLoanOffer.mtpInvoicingFee,
  mainAmountAdministrationFee: firstLoanOffer.mainAmountAdministrationFee,
  agreementEndDate: firstLoanOffer.agreementEndDate,
  totalPrincipal: firstLoanOffer.totalPrincipal,
});
